{
  "promoter": {
    "gate": {
      "closed": {
        "title": "El programa está cerrado por ahora",
        "body": "El programa de promotores de Coreway no está abierto en este momento. Tu cuenta y tus ganancias están a salvo. Vuelve más tarde."
      },
      "notInvited": {
        "title": "No hay invitación para esta cuenta",
        "body": "Entraste como {{email}}, pero no hay ninguna invitación de promotor para ese correo. Cierra sesión y entra con el correo al que te llegó la invitación."
      },
      "claim": {
        "title": "Bienvenido a Coreway Partners",
        "body": "Encontramos una invitación de promotor para {{email}}. Acéptala para vincularla a esta cuenta.",
        "button": "Aceptar mi invitación",
        "busy": "Aceptando…"
      },
      "setPassword": {
        "title": "Crea una contraseña",
        "body": "Opcional. Con una contraseña podrás entrar la próxima vez sin esperar un correo.",
        "password": "Contraseña nueva",
        "confirm": "Repite la contraseña",
        "save": "Guardar contraseña",
        "saving": "Guardando…",
        "skip": "Ahora no",
        "mismatch": "Las dos contraseñas no coinciden.",
        "short": "Usa al menos 8 caracteres."
      }
    }
  }
}
